<template lang="pug">
	.plan-container.display-flex
		.logo-section
			.logo(v-if="plan.openPlan || openPlan")
				a(:href="enrollNowUrl(plan)" target="_blank" @click="track('LOGO', plan)")
					img(v-if="plan.alternative_logo_url && showAlternativeLogo" :src="plan.alternative_logo_url")
					img(v-else :src="plan.logo_url")
					img(:src="trackingPixelUrl(plan)" style="width:1px!important;height:1px!important;visibility:hidden!important" v-if="plan.tracking_pixel_urls && plan.tracking_pixel_urls.length > 0")
			.logo(v-else)
				img(:src="plan.logo_url")
			.mobile-only.mt-3(v-if="plan.openPlan || openPlan")
				a.button(:href="enrollNowUrl(plan)" target="_blank" @click="track('BUTTON', plan)")
					| OPEN PLAN
		.plan-section.display-flex.flex-column
			.display-flex.plan-info
				div.flex-auto
					h4.plan-name
						| {{plan.name}}
					.overall-rating.mobile-only.mb-3
						p.mb-0
							| Overall Rating
							icon-info.icon-info(:id="overallRatingId2")
							b-tooltip(:target="overallRatingId2" placement="top" triggers="click blur")
								.tooltip-info
									p
										| The 5-Cap Ratings represent our opinion of the attractiveness of each 529 plan, relative to all other 529 plans, based on the many factors that we feel are important.
									p
										| The fee score is derived from the analysis of costs done as part of Savingforcollege.com's 5-Cap Rating. This analysis compares total average asset-based expenses of the plan to other 529 savings plans.
									p
										| The performance score is derived from the analysis of performance as part of Savingforcollege.com’s 5-Cap Rating.
									p
										a(:href="`${sfcUrl}/5-cap-ratings/ratings-criteria`" target="_blank") More info
						cap-rating(:score="plan.state_id == statePlan.state_id ? plan.five_caps_resident : plan.five_caps_non_resident" v-if="statePlan")
						cap-rating(:score="plan.five_caps_non_resident" v-if="!statePlan")
					ul.plan-details
						li
							| State: {{plan.state_id}}
						li
							| State Tax Benefit
							icon-info.icon-info(:id="stateRatingId")
							span.benefit-value
								| {{taxDeduction(plan)}}
							b-tooltip(:target="stateRatingId" placement="top" triggers="click blur")
								.tooltip-info
									p
										| This is the maximum amount of annual contributions that can be claimed on a state tax return for a couple that is married filing jointly.
				.call-to-action.hide-on-mobile(v-if="plan.openPlan || openPlan")
					a.button(:href="enrollNowUrl(plan)" target="_blank" @click="track('BUTTON', plan)")
						| OPEN PLAN
			.ratings-section.display-flex.hide-on-mobile
				.overall-rating.flex-auto
					p
						| Overall Rating
						icon-info.icon-info(:id="overallRatingId")
						b-tooltip(:target="overallRatingId" placement="top" triggers="click blur")
							.tooltip-info
								p
									| The 5-Cap Ratings represent our opinion of the attractiveness of each 529 plan, relative to all other 529 plans, based on the many factors that we feel are important.
								p
									| The fee score is derived from the analysis of costs done as part of Savingforcollege.com's 5-Cap Rating. This analysis compares total average asset-based expenses of the plan to other 529 savings plans.
								p
									| The performance score is derived from the analysis of performance as part of Savingforcollege.com’s 5-Cap Rating.
								p
									a(:href="`${sfcUrl}/5-cap-ratings/ratings-criteria`" target="_blank") More info
					cap-rating(:score="plan.state_id == statePlan.state_id ? plan.five_caps_resident : plan.five_caps_non_resident" v-if="statePlan")
					cap-rating(:score="plan.five_caps_non_resident" v-if="!statePlan")
				.performance.flex-auto
					p
						| Performance
					star-rating(:score="plan.five_year_performance_five_star_score")
				.fee-score.flex-auto
					p
						| Fee Score
					star-rating(:score="plan.fees_five_star_score")
</template>

<script>
import IconInfo from './icon-info'
import {track} from '../../track'
import {queryParams} from '../../query_params'
import CapRating from "./cap-rating";
import StarRating from "./star-rating";

export default {
	components: {
		IconInfo,
		CapRating,
		StarRating,
	},

	props: {
		"plan": {
			default: {},
			type: Object,
			required: true
		},
		openPlan: {
			default: true
		},

		stateId: {
			default: "-"
		},

		statePlan:{
			default: null
		},

		showAlternativeLogo: {
			default: false
		}

	},

	data(){
		let stateRatingId = `state-rating-${Math.floor(Math.random()*1000000)}`
		let overallRatingId = `overall-rating-${Math.floor(Math.random()*1000000)}`
		let overallRatingId2 = `overall-rating2-${Math.floor(Math.random()*1000000)}`
		return {
			stateRatingId,
			overallRatingId,
			overallRatingId2,
			params: {},
			sfcUrl: process.env.SFC_URL
		}
	},

	mounted(){
		this.params = queryParams()
	},

	methods:{
		track(from='BUTTON', plan){
			if (plan.has_enroll_now_plus) {
				track("PLAN", `${from}_CLICK_PLUS`, plan.id, plan.state_id, { plan_name: plan.name, selected_state_id: this.stateId })
			} else {
				track("PLAN", `${from}_CLICK`, plan.id, plan.state_id, { plan_name: plan.name, selected_state_id: this.stateId })
			}

			this.$emit('click')
		},

		enrollNowUrl(plan){
			let clickSource = "enroll-now-widget-v2"

			if(plan && plan.id && plan.has_enroll_now_plus){
				for(let enroll_now_plus_url of plan.enroll_now_plus_urls){
					if(enroll_now_plus_url.publisher == this.params.company){
						return enroll_now_plus_url.url
					}
				}
				// Fallback
				return plan.enroll_now_plus_urls[0].url
			}

			if(plan && plan.id && plan.has_enroll_now){
				return plan.enroll_now_url
			}

			return `${process.env.SFC_URL}/529-plans/${plan.state_slug}/${plan.slug}`
		},
		trackingPixelUrl(plan){
			if(plan && plan.id && plan.tracking_pixel_urls && plan.tracking_pixel_urls.length > 0){
				for(let tracking_pixel_url of plan.tracking_pixel_urls){
					if(tracking_pixel_url.publisher == this.params.company){
						return tracking_pixel_url.url
					}
				}
				// Fallback
				return ""
			}
		},
		planDetailsUrl(plan){
			return `${process.env.SFC_URL}/529-plans/${plan.state_slug}/${plan.slug}`
		},
		taxDeduction(plan){
			if(!this.statePlan){
				return "N/A"
			}

			if(!this.statePlan.deduction_info.has_deduction && !this.statePlan.deduction_info.has_credit){
				return "N/A"
			}

			if(this.statePlan.deduction_info.has_parity || this.statePlan.state_id == "MN"){
				if(this.statePlan.deduction_info.has_unlimited_contributions){
					return "Unlimited"
				}else{
					return `$${this.formatPrice(this.statePlan.deduction_info.married.deduction_amount)}/yr`
				}
			}

			if(this.statePlan.id == plan.id || this.statePlan.state_id == plan.state_id){
				if(this.statePlan.deduction_info.has_deduction){
					if(this.statePlan.deduction_info.has_unlimited_contributions){
						return "Unlimited"
					}else{
						return `$${this.formatPrice(this.statePlan.deduction_info.married.deduction_amount)}/yr`
					}
				}

				if(this.statePlan.deduction_info.has_credit){
					return `$${this.formatPrice(this.statePlan.deduction_info.married.credit_amount)}/yr`
				}
			}

			return "N/A"
		},
		formatPrice(value) {
			let val = (value/1).toFixed(0).replace('.', ',')
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		},
	}
}
</script>

<style lang="stylus" scoped>
	.mobile-only
		display: none
	.display-flex
		display flex
	.flex-column
		flex-direction column
	.flex-auto
		flex: auto
	.icon-info
		cursor: pointer
		position relative
		top: -1px
		margin-left: 4px
		margin-right: 4px
	.button
		color: #222
		margin 0
		background: #A6ECE3;
		font-weight: 600;
		font-size: 14px;
		line-height: 15px;
		text-align: center;
		letter-spacing: 0.8px;
		text-transform: uppercase;
		padding: 14px 17px
		-webkit-box-shadow none
		box-shadow: none
		border-radius 0px
		border 0px
		cursor: pointer;
		text-decoration: none
		white-space: nowrap
		display inline-block
		vertical-align: middle;
		-webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
		transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
		-o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
		transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
		transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
		&:hover
		&:active
		&:focus
			text-decoration: none
			background: #1CD5BD
	.plan-container
		background: #FFFFFF;
		border: 1px solid #D4D4D4;
		box-sizing: border-box;
		-webkit-box-shadow: 4px 4px 0px #EEEEEE;
		box-shadow: 4px 4px 0px #EEEEEE;
		padding 25px
		.logo-section
			margin-right 15px
		.plan-name
			font-weight: 600;
			font-size: 15px;
			line-height: 17px;
			margin-bottom 13px
			margin-right 30px
		.logo
			img
				width: 120px
		.plan-section
			flex: auto
		.plan-details
			margin 0 0 20px 0
			padding 0
			list-style none
			li
				font-style: normal;
				font-weight: normal;
				font-size: 14px;
				line-height: 18px;
				margin-bottom 2px
		.ratings-section
			p
				font-size: 14px;
				line-height: 18px;
				margin-bottom 0

		@media(max-width: 490px)
			.hide-on-mobile
				display: none
			.mobile-only
				display: block
			.plan-name
				margin-right 0px
			.plan-details
				margin-bottom 0px
				.icon-info
					margin-right 8px !important
				.benefit-value
					margin-left 0px !important


</style>
